import styled from 'styled-components';
import { Table } from 'antd';

export const Container = styled(Table)`
  overflow: auto;
  .ant-table-thead > tr > th.table-action,
  .ant-table-tbody > tr > td.table-action {
    max-width: ${(props) => props.actionSize} !important;
    width: ${(props) => props.actionSize} !important;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
  .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
  .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
  .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background-color: rgba(255, 187, 0, 0.1);
  }

  svg {
    color: #2e394b !important;
  }

  button:hover {
    svg {
      color: #ffbb00 !important;
    }
  }

  .ant-table-thead > tr > th {
    color: #2e394b;
    font-weight: bold;
  }

  .ant-table-pagination {
    position: relative;
    display: flex;
    float: none;
    justify-content: flex-end;

    .ant-pagination-total-text {
      font-weight: bold;
      color: #ffbb00;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  align-items: center;

  width: 100%;
  margin-bottom: 20px;

  .search-field {
    max-width: 250px;
    margin-right: 5px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: ${(props) => (props.align ? props.align : '')};
  justify-content: ${(props) => (props.justify ? props.justify : '')};
  margin-top: ${(props) => (props.isMobile ? '20px' : '')};

  .ll-btn {
    background: transparent;

    span > svg {
      fill: ${(props) => props.theme.iconTableColor};
      color: ${(props) => props.theme.iconTableColor};
    }

    &:hover {
      background: transparent;

      span > svg {
        fill: ${(props) => props.theme.iconTableColorHover};
        color: ${(props) => props.theme.iconTableColorHover};
      }
    }
  }
`;

export const TableColumn = styled(Table.Column)``;
